import { useQuery } from '@tanstack/react-query'
import { OpalApiRequestParams, OpalApiResponseDocument } from '@opallabs/api'
import { plans } from '../../../BFF'
import { globalQueryKeys } from '../../queryKeys'

type ReadPlansResponse = OpalApiResponseDocument<'ReadPlansBFFV1', 200>

type PlansQuery = OpalApiRequestParams<'ReadPlansBFFV1'>['query']

type UseReadViewsParams = {
  enabled?: boolean
  filter: OpalApiRequestParams<'ReadPlansBFFV1'>['query']['filter']
  workspaceUuid: string
}

type UseReadViewsOptions<T = ReadPlansResponse> = UseReadViewsParams & {
  select?: (data: ReadPlansResponse) => T
}

export const getReadPlansQueryFn = (
  query: PlansQuery,
  workspaceUuid: string
) => {
  return () =>
    plans.readCollection({
      path: {
        workspace_id: workspaceUuid,
      },
      query,
    })
}

export const useReadPlans = <T = ReadPlansResponse>({
  enabled,
  filter,
  select,
  workspaceUuid,
}: UseReadViewsOptions<T>) => {
  const query: PlansQuery = {
    filter,
  }

  return useQuery({
    enabled,
    queryKey: globalQueryKeys.plansByWorkspace(workspaceUuid, query),
    queryFn: getReadPlansQueryFn(query, workspaceUuid),
    select,
  })
}
